import { IUsers } from '~/gateway/users/users.types'

export function isAdminRole(role: IUsers.Role): role is IUsers.AdminRole {
  return role === IUsers.Enum.Role.Admin || role === IUsers.Enum.Role.Owner
}
